<template>
  <el-dialog :title="title" :visible.sync="roleDialog" width="30%" :before-close="cancel">
    <div>
      <el-form :rules="rules" ref="roleForm" :model="form" label-width="80px" size="mini">
        <el-form-item label="角色名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="英文名称">
          <el-input v-model="form.enname"></el-input>
        </el-form-item>
      </el-form>
      <div class="tree_box">
        <el-tree
          :data="data"
          ref="roleAddTree"
          show-checkbox
          node-key="id"
          default-expand-all
          :default-checked-keys="checkedArr"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span v-if="data.children" class="el-icon-folder-opened"></span>
            <span v-if="!data.children" class="el-icon-document"></span>
            <span>{{ data.name }}</span>
          </span>
        </el-tree>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="roleDialog = false">取 消</el-button>
      <el-button type="primary" @click="submit('roleForm')">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
// 角色新增与编辑
import { rolePutApi, roleAddApi ,roleOneApi, menuListApi} from "@/api/api";
import { reject } from "q";

export default {
  name: "",
  data() {
    return {
      rules: {
        name: [{ required: true, message: "请输入角色名", trigger: "blur" }]
      },
      roleDialog: false,
      data: [],
      checkedArr: [],
      form: {
        id:"",
        name:"",
        enname:"",
        menuList:[]
      }
    };
  },
  props: {
    title: { type: String }
  },
  methods: {
    init(res) {
      //获取树形菜单
      menuListApi().then(res => {
        this.data = res[0].children;
      })
      if(res) {
        //获取角色详情
        roleOneApi(res.id).then(res => {
          this.form = res;
          this.getData(this.form);
        })
      } else {
        //清空树
        this.data = [];
        this.checkedArr = [];
        //清空form
        this.form = {
          id:"",
          name:"",
          enname:"",
          menuList:[]
        }
      }
      this.roleDialog = true;
    },
    // 获取树
    async getData(data) {
      let arr = [];
      data.menuList.forEach((v,i) => {
        arr.push(v.id);
      })
      this.checkedArr = arr;
    },
    cancel() {
      this.roleDialog = false;
    },
    submit(formName) {
      let { add } = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          if(this.form.id) {
            //修改
            this.update();
          } else {
            //新增
            this.add();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      this.roleDialog = false;
    },
    add() {
      let tree = this.$refs.roleAddTree;
      let arr = tree.getCheckedNodes();
      this.form.menuList = arr;
      roleAddApi(this.form).then(res => {
        this.cancel();
        elMsg("新增成功");
        this.$parent.getData();
      })
    },
    update() {
      let tree = this.$refs.roleAddTree;
      let arr = tree.getCheckedNodes();
      this.form.menuList = arr;
      rolePutApi(this.form).then(res => {
        this.cancel();
        elMsg("修改成功");
        this.$parent.getData();
      })
    }

  }
};
</script>

<style lang='less' scoped>
.tree_box {
  border: 1px solid #dcdfe6;
  padding: 6px;
  max-height: 500px;
  overflow-y:auto; 
}
.tree_box span {
  margin: 0 3px;
}
</style>